



















import willExecutorDetail from '@/components/client/view-client/will-executor-detail.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountWillExecutor, createClientAccountWillExecutor } from '@/shared/clients/client-account-will-executor';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {
        willExecutorDetail,
    },
})
export default class AddWillExecutorDialog extends Vue {
    @Prop({ required: true }) public client!: ClientAccount;
    @Prop({ required: true }) public visible!: boolean;

    private isVisible: boolean = this.visible;
    private currentExecutor: ClientAccountWillExecutor = createClientAccountWillExecutor();

    @Watch('visible')
    private onVisibleChanged(value: boolean): void {
        (this.$refs.executor as Vue).$validator.errors.clear();
        this.isVisible = value;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private async onAddExecutor(): Promise<void> {
        const isValid = await (this.$refs.executor as Vue).$validator.validateAll('executor-details');

        if (!isValid) {
            return;
        }

        this.$emit('ok', { ...this.currentExecutor });
    }
}
